// Module
var code = "<filter-tag ng-if=\"$ctrl.isReady\"> <info> <tittle>Filter applied:</tittle> <name ng-bind=\"$ctrl.filterName\"></name> </info> <md-icon ng-click=\"$ctrl.filterRemove()\" title=\"Remove filter\">highlight_off</md-icon> </filter-tag> ";
// Exports
module.exports = code;